import { useEffect, useRef } from 'react';

export default function ParticleCanvas() {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    let animId = 0;
    let W = 0;
    let H = 0;

    const resize = () => {
      W = canvas.width = window.innerWidth;
      H = canvas.height = window.innerHeight;
    };

    const g = ctx;

    class Particle {
      x = 0;
      y = 0;
      vx = 0;
      vy = 0;
      r = 0;
      alpha = 0;
      color = '';

      constructor() {
        this.reset();
      }

      reset() {
        this.x = Math.random() * W;
        this.y = Math.random() * H;
        this.vx = (Math.random() - 0.5) * 0.35;
        this.vy = (Math.random() - 0.5) * 0.35;
        this.r = Math.random() * 1.5 + 0.3;
        this.alpha = Math.random() * 0.35 + 0.08;
        const palette = ['190,81,3', '255,206,27', '6,148,148', '183,65,14'] as const;
        this.color = palette[Math.floor(Math.random() * palette.length)]!;
      }

      update() {
        this.x += this.vx;
        this.y += this.vy;
        if (this.x < 0 || this.x > W || this.y < 0 || this.y > H) this.reset();
      }

      draw() {
        g.beginPath();
        g.arc(this.x, this.y, this.r, 0, Math.PI * 2);
        g.fillStyle = `rgba(${this.color},${this.alpha})`;
        g.fill();
      }
    }

    resize();
    const particles: Particle[] = Array.from({ length: 70 }, () => new Particle());

    const animate = () => {
      g.clearRect(0, 0, W, H);
      particles.forEach((p) => {
        p.update();
        p.draw();
      });

      for (let i = 0; i < particles.length; i++) {
        for (let j = i + 1; j < particles.length; j++) {
          const dx = particles[i].x - particles[j].x;
          const dy = particles[i].y - particles[j].y;
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < 90) {
            g.beginPath();
            g.moveTo(particles[i].x, particles[i].y);
            g.lineTo(particles[j].x, particles[j].y);
            g.strokeStyle = `rgba(190,81,3,${0.1 * (1 - dist / 90)})`;
            g.lineWidth = 0.5;
            g.stroke();
          }
        }
      }
      animId = requestAnimationFrame(animate);
    };

    animate();
    window.addEventListener('resize', resize);

    return () => {
      cancelAnimationFrame(animId);
      window.removeEventListener('resize', resize);
    };
  }, []);

  return <canvas ref={canvasRef} id="odc-particles" aria-hidden />;
}
